import React, { useState, useEffect, useRef } from 'react';

import card1 from '../assets/cards/card 1.png';
import card2 from "../assets/cards/card 2.png";
import card3 from "../assets/cards/card 3.png";


import { ArrowRight, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import wallpaper from '../assets/wallpaper.png';
import ScrollToHashElement from '../pages/ScrollToHashElement'; // 👈 Import here

const EkalakaarHelp = () => {
  const navigate = useNavigate();
  const videoRef = useRef(null);
const [isVideoVisible, setIsVideoVisible] = useState(false);
 const [currentSlide, setCurrentSlide] = useState(0); // ✅


useEffect(() => {
  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting && currentSlide === 0) {
        setIsVideoVisible(true);
      }
    },
    { threshold: 0.5 }
  );

  const target = videoRef.current;
  if (target && currentSlide === 0) {
    observer.observe(target);
  }

  return () => {
    if (target) {
      observer.unobserve(target);
    }
  };
}, [currentSlide]); // Re-run effect if currentSlide changes


  const slides = [
    'youtube', // Special identifier for YouTube video
    card1, 
    card2, 
    card3
  ];


  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const handleNavigate = (anchorId) => {
    navigate(`/services#${anchorId}`);
  };

  const cardData = [
    {
      id: 'enable',
      title: 'Enable',
      subtitle: 'Social Marketing',
      description:
        'Art for enabling business/social outreach to last mile stakeholders',
      hoverDescription:
        'Reach your last-mile customers and beneficiaries and create awareness.',
      background: card1,
    },
    {
      id: 'engage',
      title: 'Engage',
      subtitle: 'Conferences and Events',
      description:
        'Art for meaningful engagement and impact with high level Stakeholders.',
      hoverDescription:
        'Make corporate and institutional events more meaningful and immersive.',
      background: card2,
    },
    {
      id: 'elevate',
      title: 'Elevate',
      subtitle: 'Cultural Entertainment',
      description:
        'Art for an elevated experience for your guests on festivals/ special occasions.',
      hoverDescription:
        'Create unforgettable guest experiences for private events at elite clubs and hotels',
      background: card3,
    },
  ];

  return (
    //     <section id="value" className="relative bg-white pt-20 font-[Poppins] overflow-hidden">
    //       <ScrollToHashElement />
    //       {/* Mandala Backgrounds */}
    //       <img
    //         src={wallpaper}
    //         alt="Mandala Top Right"
    //         className="absolute top-[-210px] right-[-150px] w-[500px] md:w-[500px] opacity-[0.7] z-0 hidden md:block"
    //       />
    //       <img
    //         src={wallpaper}
    //         alt="Mandala Top Left"
    //         className="absolute top-[-210px] left-[-150px] w-[500px] md:w-[500px] opacity-[0.7] z-0 hidden md:block"
    //       />
    //       <img
    //         src={wallpaper}
    //         alt="Mandala bottom Right"
    //         className="absolute bottom-[-300px] right-[-270px] w-[300px] md:w-[600px] opacity-[0.7] z-0 hidden md:block"
    //       />
    //       <img
    //         src={wallpaper}
    //         alt="Mandala bottom Left"
    //         className="absolute bottom-[-300px] left-[-270px] w-[300px] md:w-[600px] opacity-[0.7] z-0 hidden md:block"
    //       />
    //       <div className="w-full max-w-[1800px] mx-auto px-4 md:px-[40px]">
    //       <h2 className="text-center text-[#AD2F3B] font-bold text-[28px] md:text-[36px] max-[440px]:text-[20px] mb-8 md:mb-12 underline decoration-[#AD2F3B] decoration-2 underline-offset-[10px]">
    //   VALUE TO YOU
    // </h2>

    //         <p className="text-center text-gray-700 text-[16px] md:text-[22px] max-w-[900px] mx-auto mb-12 md:mb-16 px-4 max-[440px]:text-[14px]">
    //           Communicate effectively with your audience through curated traditional
    //           performing arts that inspire, engage, and create impact.
    //         </p>

    //         <div className="w-full flex flex-col lg:flex-row items-start justify-between gap-8 lg:gap-16">
    //   {/* Left Cards */}
    // <div className="!w-full lg:!w-[500px] !flex !flex-col !gap-6 mx-auto max-[440px]:!h-[550px]">
    //     {cardData.map((item, index) => (
    //     <div
    //       key={index}
    //       className="!relative !border-2 !border-[#AD2F3B] !rounded-xl !px-4 md:!px-6 !py-4 !shadow-md hover:!shadow-lg !transition !duration-300 !ease-in-out !flex !flex-col !items-center !text-center !overflow-hidden group !h-[220px] md:!h-[230px] max-[440px]:!h-[500px] max-[440px]:!px-3 max-[440px]:!py-3"
    //     >
    //       {/* Gradient Background */}
    //       <div className="!absolute !inset-0 !z-0 !bg-gradient-to-b !from-[#FAECEE] !via-white !to-[#F8E3E5] md:group-hover:!opacity-0 !transition-opacity !duration-500" />

    //       {/* Hover Background Image - Only for large screens */}
          // <img
          //   src={item.background}
          //   alt={`${item.title} bg`}
          //   className="!absolute !inset-0 !w-full !h-full !object-cover !opacity-0 md:group-hover:!opacity-20 !scale-0 md:group-hover:!scale-125 !transition-all !duration-500 !ease-out !z-0"
          // />

    //       {/* Card Content */}
    //       <div className="!z-10 !flex !flex-col !items-center !h-full !justify-between !w-full">
    //         {/* Top Content - Modified for mobile */}
    //         <div className="!flex !flex-col !items-center !w-full">
    //           <h3 className="!text-[#AD2F3B] !font-bold !text-[20px] md:!text-[24px] md:group-hover:!hidden max-[440px]:!text-[16px]">
    //             {item.title}
    //           </h3>

    //           <p className="!text-[16px] md:!text-[20px] !text-black-700 !mt-2 !mb-3 md:group-hover:!hidden max-[440px]:!text-[14px] max-[440px]:!mt-1 max-[440px]:!mb-2">
    //             {item.subtitle}
    //           </p>

    //           <div className="!w-full !max-w-[400px] !h-[2px] !bg-[#AD2F3B] !mb-3 md:group-hover:!hidden max-[440px]:!mb-2"></div>

    //           <p className="!text-[14px] md:!text-[18px] !text-gray-600 !mb-3 !px-2 md:group-hover:!hidden max-[440px]:!text-[13px] max-[440px]:!leading-tight max-[440px]:!mb-2">
    //             {item.description}
    //           </p>

    //           {/* Hover Description - Always hidden on mobile */}
    //           <div className="!hidden md:group-hover:!flex !items-center !justify-center !mt-1 !mb-3 !w-full">
    //             <div className="!w-full !max-w-[460px] !h-[150px] !bg-white !border !border-[#AD2F3B] !rounded-lg !flex !items-center !justify-center !px-4 !py-2 !text-center !mx-2">
    //               <p className="!text-[16px] md:!text-[19px] !text-black-700">
    //                 {item.hoverDescription}
    //               </p>
    //             </div>
    //           </div>
    //         </div>

    //         {/* Button - Unchanged */}
    //         <button
    //           onClick={() => handleNavigate(item.id)}
    //           className="!text-[#AD2F3B] !text-sm !border !border-[#AD2F3B] !px-6 !py-2 !rounded-full !flex !items-center !gap-1 hover:!bg-[#AD2F3B] hover:!text-white !transition max-[440px]:!mt-2 max-[440px]:!text-[13px] max-[440px]:!px-4 max-[440px]:!py-1"
    //         >
    //           View more <ArrowRight size={14} />
    //         </button>
    //       </div>
    //     </div>
    //   ))}
    // </div>

    //   {/* Right Image Slider */}
    // <div className="w-full lg:w-[calc(100%-550px)] flex flex-col items-center justify-center gap-4 mt-6">
    //   {/* Main content with side arrows (hidden on mobile) */}
    //   <div className="w-full flex items-center justify-center">
    //     <button
    //       className="p-1 hidden md:flex items-center justify-center h-full min-h-[300px] md:min-h-[650px] rounded-full mr-4"
    //       onClick={prevSlide}
    //     >
    //       <ArrowLeft className="w-8 h-8 text-[#AD2F3B]" />
    //     </button>

    //     <div ref={videoRef} className="relative w-full h-[250px] md:h-[650px] overflow-hidden rounded-xl shadow-lg">
    //       {slides[currentSlide] === 'youtube' ? (
    //         isVideoVisible ? (
    //           <iframe
    //             width="100%"
    //             height="100%"
    //             src="https://www.youtube.com/embed/xdxmXlk880w?autoplay=1&mute=1&loop=1&playlist=xdxmXlk880w&cc_load_policy=0"
    //             title="YouTube video player"
    //             frameBorder="0"
    //             allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    //             referrerPolicy="strict-origin-when-cross-origin"
    //             allowFullScreen
    //             className="absolute inset-0 w-full h-full object-cover"
    //           />
    //         ) : (
    //           <div className="absolute inset-0 w-full h-full bg-black" />
    //         )
    //       ) : (
    //         <img
    //   src={slides[currentSlide]}
    //   alt="Slide"
    //   className="absolute inset-0 w-full h-full
    //              object-cover max-[440px]:object-cover
    //              max-[440px]:bg-black
    //               "
    // />

    //       )}
    //     </div>

    //     <button
    //       className="p-1 hidden md:flex items-center justify-center h-full min-h-[400px] md:min-h-[700px] rounded-full ml-4"
    //       onClick={nextSlide}
    //     >
    //       <ArrowRight className="w-8 h-8 text-[#AD2F3B]" />
    //     </button>
    //   </div>

    //   {/* Bottom arrows (visible only on mobile) */}
    //   <div className="flex md:hidden items-center !justify-center gap-8 mt-2">
    //     <button
    //       className="p-2 bg-white rounded-full shadow-md"
    //       onClick={prevSlide}
    //     >
    //       <ArrowLeft className="w-6 h-6 text-[#AD2F3B]" />
    //     </button>
    //     <button
    //       className="p-2 bg-white rounded-full shadow-md"
    //       onClick={nextSlide}
    //     >
    //       <ArrowRight className="w-6 h-6 text-[#AD2F3B]" />
    //     </button>
    //   </div>
    // </div>
    // </div>

    //         <div className="mt-[40px] md:mt-[90px] flex justify-center mb-[100px]">
    //           <button
    //             onClick={() => navigate('/book-performance')}
    //             className="bg-[#AD2F3B] text-white text-[18px] sm:text-[20px] rounded-full transition-shadow duration-300 hover:shadow-[0_6px_10px_rgba(0,0,0,0.25)]
    //               w-[250px] h-[60px]
    //               max-[440px]:w-[200px] max-[440px]:h-[45px] max-[440px]:text-[14px] max-[440px]:self-center"
    //           >
    //             Book Performance
    //           </button>
    //         </div>
    //       </div>
    //     </section>

    <section
      id="value"
      className="relative bg-white pt-8 md:pt-10 lg:pt-12 xl:pt-16 font-[Poppins] overflow-hidden"
    >
      <ScrollToHashElement />

      {/* Mandala Backgrounds */}
      {/* Top Right */}
<img
  src={wallpaper}
  alt="Mandala Top Right"
  className="absolute 
    top-[-6rem] md:top-[-7rem] lg:top-[-9rem] xl:top-[-10rem] 
    right-[-5rem] md:right-[-7rem] lg:right-[-6rem] xl:right-[-7rem]
    w-[20rem] md:w-[17rem] lg:w-[19rem] xl:w-[25rem] 
    opacity-[0.7] z-0 hidden md:block"
/>

{/* Top Left */}
<img
  src={wallpaper}
  alt="Mandala Top Left"
  className="absolute 
    top-[-6rem] md:top-[-7rem] lg:top-[-9rem] xl:top-[-10rem] 
    left-[-5rem] md:left-[-7rem] lg:left-[-6rem] xl:left-[-7rem]
    w-[20rem] md:w-[17rem] lg:w-[19rem] xl:w-[25rem] 
    opacity-[0.7] z-0 hidden md:block"
/>

{/* Bottom Right */}
<img
  src={wallpaper}
  alt="Mandala Bottom Right"
  className="absolute 
    bottom-[-9vw] md:bottom-[-10.3rem] lg:bottom-[-10rem] xl:bottom-[-15rem] 
    right-[-6vw] md:right-[-7rem] lg:right-[-6rem] xl:right-[-7.3rem]
    w-[18vw] md:w-[17rem] lg:w-[19rem] xl:w-[25rem] 
    opacity-[0.7] z-0 hidden md:block"
/>

{/* Bottom Left */}
<img
  src={wallpaper}
  alt="Mandala Bottom Left"
  className="absolute 
    bottom-[-9vw] md:bottom-[-10.3rem] lg:bottom-[-10rem] xl:bottom-[-15rem] 
    left-[-6vw] md:left-[-7rem] lg:left-[-6rem] xl:left-[-7.3rem]
    w-[18vw] md:w-[17rem] lg:w-[19rem] xl:w-[25rem] 
    opacity-[0.7] z-0 hidden md:block"
/>


      <div className="w-full max-w-[90rem] mx-auto px-4 sm:px-5 md:px-6 lg:px-8">
        {/* Heading with precise font scaling */}
<h2 className="text-center text-[#AD2F3B] font-bold 
  text-[1.25rem]       // sm: 20px
  sm:text-[2rem]       // md: 32px
  md:text-[2rem]       // lg: 34px
  lg:text-[2.14rem]    // xl: 36px
  xl:text-[2.25rem] 
  2xl:text-[2.25rem]
  sm:mb-4 md:mb-8 lg:mb-8 xl:mb-12  
  underline decoration-[#AD2F3B] decoration-2 underline-offset-[8px]  md:underline-offset-[10px] "
>
  VALUE TO YOU
</h2>


<p className="text-center text-gray-700 
  text-[0.875rem]       // sm: 14px
  sm:text-[1.125rem]    // md: 18px
  md:text-[1.25rem]     // lg: 20px
  lg:text-[1.375rem]    // xl: 22px
  xl:text-[1.375rem]
  2xl:text-[1.375rem]
  max-w-[50rem] mx-auto mb-6 sm:mb-8 md:mb-8 lg:mb-12 xl:mb-18 px-4 leading-snug md:leading-normal"
>
  Communicate effectively with your audience through curated traditional
  performing arts that inspire, engage, and create impact.
</p>


        <div className="w-full flex flex-col lg:flex-row items-stretch justify-between gap-3 md:gap-4 lg:gap-5 xl:gap-6">
          {/* Left Cards - 38% width (less than 40%) */}
          <div className="w-full lg:w-[38%] xl:w-[35%]  md:w-[90%] flex flex-col lg:gap-2 xl:gap-4 sm:gap-6 gap-4 mx-auto">
{cardData.map((item, index) => (
  <div
    key={index}
    className="group relative border-2 border-[#AD2F3B] rounded-lg px-3  shadow-sm hover:shadow-md transition-all duration-300 ease-in-out flex flex-col h-auto lg:h-auto xl:h-auto justify-center !overflow-hidden"
  >
    {/* Gradient Background */}
    <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#FAECEE] via-white to-[#F8E3E5] opacity-100 lg:group-hover:opacity-0 transition-opacity duration-500 rounded" />

    {/* Background Image on Hover */}
    {/* <img
      src={item.background}
      alt={`${item.title} bg`}
      className="absolute inset-0 w-full h-full object-cover opacity-0 scale-100 
                 !lg:group-hover:opacity-20 !lg:group-hover:scale-110 
                 transition-all duration-500 ease-out z-0 rounded"
    /> */}

    <img
            src={item.background}
            alt={`${item.title} bg`}
            className="!absolute !inset-0 !w-full !h-full !object-cover !opacity-0 md:group-hover:!opacity-20 !scale-0 md:group-hover:!scale-125 !transition-all !duration-500 !ease-out !z-0 "
          />

    {/* Card Content */}
    <div className="z-10 flex flex-col justify-center items-center xl:py-3 py-2 text-center h-full px-2">
      {/* Static Content */}
      <div className="lg:group-hover:hidden">
        <h3 className="text-[#AD2F3B] font-bold text-[1rem] sm:text-[1.125rem] md:text-[1.25rem] lg:text-[1rem] xl:text-[1.425rem]">
          {item.title}
        </h3>
        <p className="text-[0.75rem] sm:text-[0.875rem] md:text-[1rem] lg:text-[0.75rem] xl:text-[1rem] text-black mt-1 mb-1">
          {item.subtitle}
        </p>
        <div className="w-[90%] mx-auto h-[1px] bg-[#AD2F3B] my-2" />
        <p className="text-[0.6875rem] sm:text-[0.75rem] md:text-[0.875rem] lg:text-[0.7rem] xl:text-[0.9rem] text-gray-600 leading-tight px-1">
          {item.description}
        </p>
      </div>

      {/* Hover Content - lg and up */}
      <div className="hidden lg:group-hover:flex flex-col justify-center items-center h-full">
        <div className="w-full max-w-[95%] bg-white border border-[#AD2F3B] rounded p-3">
          <p className="text-[0.875rem] md:text-[1rem] lg:text-[1.125rem] text-black leading-snug">
            {item.hoverDescription}
          </p>
        </div>
      </div>

      {/* Button - always visible */}
      <div className="mt-3">
        <button
          onClick={() => handleNavigate(item.id)}
          className="text-[#AD2F3B] text-[0.75rem] sm:text-[0.8125rem] md:text-[0.875rem] lg:text-[0.8375rem] border border-[#AD2F3B] px-3 py-1 rounded-full flex items-center gap-1 hover:bg-[#AD2F3B] hover:text-white transition"
        >
          View More <ArrowRight size={14} />
        </button>
      </div>
    </div>
  </div>
))}

          </div>

          {/* Right Image/Video Slider - 60% width */}
          <div className="w-full lg:w-[60%] flex items-center justify-center my-auto">
            <div className="relative w-full flex items-center h-full">
              <button
                className="hidden md:flex items-center justify-center p-1 rounded-full mr-1 lg:mr-2 shrink-0"
                onClick={prevSlide}
              >
                <ArrowLeft className="w-4 md:w-5 lg:w-6 text-[#AD2F3B]" />
              </button>

              <div
                ref={videoRef}
                className="relative w-full h-full min-h-[12rem] sm:min-h-[14rem] md:min-h-[16rem] lg:min-h-[18rem] xl:min-h-[20rem] rounded-lg shadow-lg overflow-hidden flex items-center justify-center"
                style={{ aspectRatio: "4/3" }}
              >
                {slides[currentSlide] === "youtube" ? (
                  isVideoVisible ? (
                    <iframe
                      width="100%"
                      height="100%"
                      src="https://www.youtube.com/embed/xdxmXlk880w?autoplay=1&mute=1&loop=1&playlist=xdxmXlk880w&cc_load_policy=0"
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                      className="absolute inset-0 w-full h-full object-cover"
                    />
                  ) : (
                    <div className="absolute inset-0 w-full h-full bg-black" />
                  )
                ) : (
                  <img
                    src={slides[currentSlide]}
                    alt="Slide"
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                )}
              </div>

              <button
                className="hidden md:flex items-center justify-center p-1 rounded-full ml-1 lg:ml-2 shrink-0"
                onClick={nextSlide}
              >
                <ArrowRight className="w-4 md:w-5 lg:w-6 text-[#AD2F3B]" />
              </button>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <div className="mt-6 md:mt-7 lg:mt-8 xl:mt-10 flex justify-center mb-8 md:mb-9 lg:mb-10 xl:mb-12">
          <button
            onClick={() => navigate("/book-performance")}
            className="bg-[#AD2F3B] text-white text-[0.6875rem] sm:text-[0.75rem] md:text-[0.8125rem] lg:text-[0.875rem] xl:text-[0.9375rem] rounded-full transition-shadow duration-300 hover:shadow-md 
          w-[9rem] sm:w-[10rem] md:w-[11rem] lg:w-[12rem] h-[2rem] sm:h-[2.25rem] md:h-[2.5rem] lg:h-[2.75rem]"
          >
            Book Performance
          </button>
        </div>
      </div>
    </section>
  );
};

export default EkalakaarHelp;
